import type { StaffTicket, StaffTicketMessage } from '@shared/web/types';

export const SUPPORT_READ_EVENT = 'support-message-read';
const receipts = new Map<string, number>();

function receiptKey(userId: string, ticketId: string) {
  return `support-read:${userId}:${ticketId}`;
}

function readReceipt(key: string) {
  let read = receipts.get(key) ?? 0;
  try { read = Math.max(Number(localStorage.getItem(key)) || 0, read); } catch { /* Storage may be blocked. */ }
  return read;
}

export function hasUnreadSupportMessage(ticket: StaffTicket, userId: string) {
  const message = ticket.latestMessage;
  if (ticket.status === 'resolved' || !message) return false;
  const relevant = ticket.assignee
    ? ticket.assignee.id === userId && message.authorUserId !== userId
    : message.authorRole === 'creator' && ticket.awaiting === 'agency';
  if (!relevant) return false;
  const key = receiptKey(userId, ticket.id);
  return new Date(message.createdAt).getTime() > readReceipt(key);
}

export function markSupportTicketRead(ticket: StaffTicket, userId: string) {
  // A full thread is the receipt, not a queue refresh or an opened launcher.
  const latest = ticket.messages?.reduce<StaffTicketMessage | undefined>((last, message) =>
    !last || new Date(message.createdAt).getTime() > new Date(last.createdAt).getTime() ? message : last,
    undefined);
  if (!latest) return;
  const key = receiptKey(userId, ticket.id);
  const timestamp = new Date(latest.createdAt).getTime();
  if (!Number.isFinite(timestamp) || readReceipt(key) >= timestamp) return;
  receipts.set(key, timestamp);
  try { localStorage.setItem(key, String(timestamp)); } catch { /* Keep the in-memory receipt. */ }
  window.dispatchEvent(new Event(SUPPORT_READ_EVENT));
}
